/* Gluca pumpkin seed oil mini-cart: shows the chosen bundle, free gifts, the Refill Plan switch
   and free shipping before checkout. Bundle data comes from the offer's bundle inputs on the page. */
(function () {
  if (window.psoCart) return;
  var root = null, cart = null, busy = false, lastFocus = null;
  var offer = document.getElementById('pso-offer');
  var BUNDLES = {};
  var GIFT_IDS = [];

  var money = function (cents) {
    var v = Math.round(cents) / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  };
  var q = function (sel) { return root.querySelector(sel); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var bottlesText = function (n) { return n + (n === 1 ? ' bottle' : ' bottles'); };
  var track = function (cta) {
    if (typeof window.psoTrack === 'function') window.psoTrack('Sleep Page CTA Click', { cta: cta, area: 'Mini cart', href: '' });
  };

  function readBundles() {
    if (!offer) return;
    if (offer.dataset.giftVariant) GIFT_IDS.push(Number(offer.dataset.giftVariant));
    if (offer.dataset.guideVariant) GIFT_IDS.push(Number(offer.dataset.guideVariant));
    offer.querySelectorAll('input[name="pso-bundle"]').forEach(function (input) {
      if (!input.dataset.variant) return;
      var label = input.closest('.pso-bundle');
      var img = label && label.querySelector('.pso-bundle__thumb img');
      var name = label && label.querySelector('.pso-bundle__name');
      BUNDLES[input.dataset.variant] = {
        bottles: Number(input.dataset.bottles) || 1,
        price: Number(input.dataset.price) || 0,
        subPrice: Number(input.dataset.subPrice) || 0,
        ref: Number(input.dataset.ref) || 0,
        plan: input.dataset.plan ? Number(input.dataset.plan) : null,
        ship: input.dataset.ship || 'every month',
        gift: input.dataset.gift === '1',
        guide: input.dataset.guide === '1',
        giftName: input.dataset.giftName || '',
        name: name ? name.textContent.trim() : '',
        img: img ? (img.currentSrc || img.src) : ''
      };
    });
  }

  function request(url, body) {
    var opts = { headers: { Accept: 'application/json' } };
    if (body) { opts.method = 'POST'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) { if (!r.ok) throw data; return data; });
    });
  }
  function load() { return request('/cart.js').then(function (c) { cart = c; paint(); return c; }); }

  function isGift(i) { return (i.properties && i.properties._gift === 'yes') || GIFT_IDS.indexOf(i.variant_id) >= 0; }
  function mainLine() { return (cart && cart.items || []).filter(function (i) { return BUNDLES[String(i.variant_id)]; })[0] || null; }
  function giftLines() { return (cart && cart.items || []).filter(isGift); }

  /* Same delivery date the offer shows ("Order today, receive by Saturday, Oct 10"). */
  function etaText() {
    var onPage = document.querySelector('.pso-delivery [data-pso-date], [data-pso-date]');
    var date = onPage && onPage.textContent.trim();
    if (!date) {
      var d = new Date();
      d.setDate(d.getDate() + (Number(onPage && onPage.dataset.days) || 7));
      date = d.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
    }
    return 'Order today, receive by <b>' + esc(date) + '</b>';
  }

  function itemHtml(line, b) {
    var onPlan = !!line.selling_plan_allocation;
    var was = b.ref > line.final_line_price ? b.ref : 0;
    var save = was ? was - line.final_line_price : 0;
    var thumb = b.img || line.image || '';
    return '<div class="pcart__item" data-key="' + esc(line.key) + '">'
      + (thumb ? '<img class="pcart__thumb" src="' + esc(thumb) + '" alt="" width="76" height="76">' : '<span class="pcart__thumb"></span>')
      + '<div><p class="pcart__iname">' + esc(line.product_title) + '</p>'
      + '<p class="pcart__ivar">' + esc((b.name ? b.name + ' · ' : '') + bottlesText(b.bottles)) + '</p>'
      + (onPlan ? '<p class="pcart__sub">&#8635; Refill Plan on</p>' : '<p class="pcart__ivar">One-time purchase</p>')
      + '</div>'
      + '<div class="pcart__ipr">' + (was ? '<span class="pcart__was">' + money(was) + '</span>' : '')
      + '<span class="pcart__now">' + money(line.final_line_price) + '</span>'
      + (save > 0 ? '<span class="pcart__isave">You save ' + money(save) + '</span>' : '')
      + '<button class="pcart__rm" type="button" data-pcart-rm aria-label="Remove ' + esc(line.product_title) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg></button>'
      + '</div></div>';
  }
  var GIFT_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M5 12v8h14v-8M12 8v12M12 8c-1.5 0-4-.6-4-2.5S10.5 3 12 8zm0 0c1.5 0 4-.6 4-2.5S13.5 3 12 8z"/></svg>';
  var cleanGiftName = function (t) { return String(t || '').replace(/\s*\(free gift\)\s*/i, '').trim(); };
  var GIFT_LINE = {
    mask: 'Blocks the early light so you drift back to sleep',
    guide: 'Your 3 AM Reset routine, ready to read today'
  };
  function giftBlurb(name) { return /guide/i.test(name) ? GIFT_LINE.guide : GIFT_LINE.mask; }
  function giftCard(name, img, locked) {
    return '<div class="pcart__gift' + (locked ? ' is-locked' : '') + '">'
      + '<span class="pcart__gift-ribbon">' + GIFT_ICON + (locked ? 'Free gift with the Refill Plan' : 'Your free gift') + '</span>'
      + '<span class="pcart__gift-img">' + (img ? '<img src="' + esc(img) + '" alt="" width="72" height="72">' : GIFT_ICON) + '</span>'
      + '<div class="pcart__gift-info"><p class="pcart__gift-name">' + esc(name) + '</p><p class="pcart__gift-blurb">' + esc(giftBlurb(name)) + '</p></div>'
      + (locked ? '<button type="button" class="pcart__unlock" data-pcart-refill-toggle>Claim it</button>' : '<span class="pcart__gift-free">FREE</span>')
      + '</div>';
  }
  function giftHtml(g) { return giftCard(cleanGiftName(g.product_title), g.image, false); }
  function lockedGiftHtml(name) { return giftCard(name.charAt(0).toUpperCase() + name.slice(1), offer && offer.dataset.giftImg, true); }

  function paintRefill(line, b) {
    var card = q('[data-pcart-refill]'), renew = q('[data-pcart-renew]');
    card.hidden = !line || !b || !b.plan;
    renew.hidden = true;
    if (card.hidden) return;
    var on = !!line.selling_plan_allocation;
    card.classList.toggle('is-on', on);
    var sw = q('.pcart__sw');
    sw.classList.toggle('is-on', on);
    sw.setAttribute('aria-checked', on ? 'true' : 'false');
    var refill = bottlesText(b.bottles) + ' ' + b.ship + ' for ' + money(b.subPrice);
    q('[data-pcart-refill-price]').textContent = on
      ? 'Today ' + money(line.final_line_price) + '. Then ' + refill + '.'
      : 'Pay ' + money(b.subPrice) + ' instead of ' + money(b.price) + (b.giftName ? ' + FREE ' + b.giftName : '') + '.';
    q('[data-pcart-refill-desc]').textContent = on
      ? 'A fresh ' + bottlesText(b.bottles) + ' arrive ' + b.ship + ', right as you run out. We email you before every refill. Skip or cancel anytime with one email.'
      : 'Turn it on and your refill of ' + refill + ' arrives right as you run out. Skip or cancel anytime with one email.';
  }

  function paint() {
    if (!root || !cart) return;
    var line = mainLine();
    var b = line ? BUNDLES[String(line.variant_id)] : null;
    var gifts = giftLines();
    q('[data-pcart-count]').textContent = line ? '(' + (1 + gifts.length) + ')' : '';
    q('[data-pcart-eta]').innerHTML = etaText();
    var html = '';
    if (line) {
      html = itemHtml(line, b);
      if (line.selling_plan_allocation) html += gifts.map(giftHtml).join('');
      else if (b && b.plan && b.giftName) html += lockedGiftHtml(b.giftName);
    } else {
      html = '<div class="pcart__empty"><p>Your cart is empty.</p><button type="button" data-pcart-close>Choose my supply</button></div>';
    }
    q('[data-pcart-items]').innerHTML = html;
    paintRefill(line, b);
    q('[data-pcart-trust]').hidden = !line;
    var save = line && b && b.ref > line.final_line_price ? b.ref - line.final_line_price : 0;
    q('[data-pcart-saverow]').hidden = save <= 0;
    q('[data-pcart-save]').textContent = '-' + money(save);
    q('[data-pcart-total]').textContent = money(cart.total_price);
    q('[data-pcart-checkout]').disabled = !line;
  }

  /* Keep the offer's Refill Plan box in step with the cart switch. */
  function syncPage(on) {
    var box = offer && offer.querySelector('[data-pso-sub]');
    if (box && box.checked !== on) { box.checked = on; box.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  function toggleRefill() {
    var line = mainLine();
    var b = line && BUNDLES[String(line.variant_id)];
    if (!b || !b.plan || busy) return;
    busy = true;
    var on = !line.selling_plan_allocation;
    track(on ? 'Cart: Refill Plan on' : 'Cart: Refill Plan off');
    var props = {};
    var cur = line.properties || {};
    for (var k in cur) if (k !== 'Refills') props[k] = cur[k];
    if (on) props.Refills = bottlesText(b.bottles) + ' ' + b.ship + ' at ' + money(b.subPrice) + '. Cancel anytime.';
    request('/cart/change.js', { id: line.key, quantity: 1, selling_plan: on ? b.plan : null, properties: props })
      .then(function () {
        if (on) {
          var items = [];
          if (b.gift && offer.dataset.giftVariant) items.push({ id: Number(offer.dataset.giftVariant), quantity: 1, properties: { _gift: 'yes' } });
          if (b.guide && offer.dataset.guideVariant) {
            var gp = { _gift: 'yes' };
            if (offer.dataset.guideUrl) gp['Read your guide'] = offer.dataset.guideUrl;
            items.push({ id: Number(offer.dataset.guideVariant), quantity: 1, properties: gp });
          }
          return items.length ? request('/cart/add.js', { items: items }) : null;
        }
        var updates = {};
        giftLines().forEach(function (g) { updates[g.key] = 0; });
        return Object.keys(updates).length ? request('/cart/update.js', { updates: updates }) : null;
      })
      .catch(function () {})
      .then(function () { busy = false; syncPage(on); return load(); });
  }

  function removeAll() {
    var updates = {};
    (cart && cart.items || []).forEach(function (i) { updates[i.key] = 0; });
    track('Cart: removed bundle');
    request('/cart/update.js', { updates: updates }).catch(function () {}).then(load);
  }

  function checkout(btn) {
    btn.disabled = true;
    track('Cart: secure checkout');
    // Meta InitiateCheckout is sent once by Shopify's Customer events pixel when checkout loads.
    window.location.href = '/checkout';
  }

  function open() {
    if (!root) return Promise.resolve();
    lastFocus = document.activeElement;
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('pcart-lock');
    q('.pcart__x').focus();
    track('Cart: opened');
    return load();
  }
  function close() {
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('pcart-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onClick(e) {
    var t = e.target;
    if (t.closest('[data-pcart-close]')) { track('Cart: closed'); close(); return; }
    if (t.closest('[data-pcart-checkout]')) { checkout(t.closest('[data-pcart-checkout]')); return; }
    if (t.closest('[data-pcart-refill-toggle]')) { toggleRefill(); return; }
    if (t.closest('[data-pcart-rm]')) removeAll();
  }

  function mount() {
    root = document.getElementById('pcart');
    if (!root) return;
    if (root.parentNode !== document.body) document.body.appendChild(root);
    readBundles();
    root.addEventListener('click', onClick);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
    // Coming back from checkout with the back button: re-enable the checkout button.
    window.addEventListener('pageshow', function () { var go = q('[data-pcart-checkout]'); if (go) go.disabled = false; });
  }

  window.psoCart = { open: open, reload: load };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();
